<template>
    <div class="mt-2" v-if="account">
        <v-card class="pa-4 ma-3">
            <v-layout align-center justify-center>
                <v-card-title
                    class="text-xs-center headline px-0 mb-2 pt-0 mb-0 pb-0"
                    >{{ getMessage("TITLE") }}</v-card-title
                >
            </v-layout>
            <v-form ref="form">
                <v-layout row>
                    <v-btn
                        small
                        class="mb-0 mt-0"
                        color="success"
                        :loading="uploading"
                        style="height: 35px;"
                        @click="pickFile()"
                        ><v-icon dark left>mdi-cloud-upload</v-icon
                        >Upload</v-btn
                    >
                    <!-- <div class="mt-2 ml-2">
                            Application Status:
                            {{
                                kollelApplicationDocuments.length
                                    ? "Uploaded"
                                    : "Not Uploaded"
                            }}
                        </div> -->
                    <input
                        type="file"
                        style="display: none"
                        ref="files"
                        accept="image/*,.pdf"
                        @change="onFilePicked($event)"
                    />
                    <v-btn
                        v-if="kollelApplication.documentURL"
                        small
                        class="mt-0 ml-3"
                        @click="openDocument()"
                        style="height: 35px;"
                    >
                        <v-icon color="red" left dark>mdi-file-pdf</v-icon>
                        <span class="mr-2">Kollel Application</span>
                        <v-icon right>mdi-download</v-icon>
                    </v-btn>
                    <v-btn
                        class="mt-0"
                        v-if="kollelApplication.documentURL"
                        small
                        icon
                        @click.stop="deleteDocument()"
                        ><v-icon color="red">mdi-delete-forever</v-icon></v-btn
                    >
                </v-layout>
                <div>
                    <div class="text-xs-center mb-2">
                        {{ getMessage("FIRST_PARAGRAPH") }}
                    </div>
                    <div class="text-xs-center mb-2">
                        {{ getMessage("SECOND_PARAGRAPH") }}
                    </div>
                    <div class="text-xs-center mb-3 caption">
                        אלס אַן ערנסטער יונגערמאַן אַ בן תורה רעכענען מיר אויף
                        אייער אָרנטליכקייט און ישרות אויסצופילן די בייגעלייגטע
                        אפליקאציע בנאמנות און דאס אונטערשרייבן באחריות.
                    </div>
                    <v-divider
                        style="border-color: #4caf50; margin-top: 13px;"
                        class="mt-2 pt-2"
                    ></v-divider>
                    <v-layout row class="mx-3">
                        <div class="font-weight-medium mr-2">
                            Name:
                        </div>
                        <div>{{ kollelApplication.name }}</div>
                        <v-spacer></v-spacer>
                        <div class="font-weight-medium mr-2">
                            Address:
                        </div>
                        <div>{{ kollelApplication.address }}</div>
                        <v-spacer></v-spacer>
                        <div class="font-weight-medium mr-2">
                            Phone:
                        </div>
                        <div>{{ kollelApplication.homePhone }}</div>
                    </v-layout>
                    <v-divider
                        style="border-color: #4caf50; margin-top: 13px;"
                        class="mt-2 pt-2"
                    ></v-divider>
                    <v-layout row justify-end align-end class="mx-3">
                        <v-spacer></v-spacer>
                        <v-select
                            style="max-width: 300px;"
                            color="success"
                            :items="['ניין', 'יא']"
                            v-model="kollelApplication.onKollelPayroll"
                            class="mb-0 mt-2"
                            :rules="required"
                            reverse
                            label="באקומט כולל געלט"
                        ></v-select>
                        <v-select
                            style="max-width: 300px;"
                            color="success"
                            :items="['ניין', 'יא']"
                            v-model="kollelApplication.kollelTimeAllDay"
                            class="mb-0 mt-2 ml-3"
                            :rules="required"
                            reverse
                            label="לערנט איר אין כולל א גאנצן טאג"
                        ></v-select>
                    </v-layout>
                    <v-layout row class="pa-0 ma-0">
                        <v-divider
                            style="border-color: #4caf50; margin-top: 13px;"
                            class="mt-2 pt-2"
                        ></v-divider>
                        <div class="font-weight-medium ml-0">
                            {{ getMessage("KOLLEL_TITLE") }}
                        </div>
                    </v-layout>
                    <v-layout row justify-end align-end>
                        <v-spacer></v-spacer>
                        <v-radio-group
                            v-model="kollelApplication.kollelType"
                            row
                            style="max-width: 326px;"
                        >
                            <v-radio
                                label="אנדערע כולל"
                                value="other"
                                color="success"
                            ></v-radio>
                            <v-radio
                                label="כולל אברכים תורה ויראה"
                                value="satmar"
                                color="success"
                            ></v-radio>
                        </v-radio-group> </v-layout
                    ><v-layout row justify-end align-end>
                        <v-spacer></v-spacer>
                        <div
                            class="text-danger mb-3"
                            v-if="
                                showKollelTypeMissing &&
                                    !kollelApplication.kollelType
                            "
                        >
                            Required
                        </div></v-layout
                    >
                    <v-layout row justify-end align-end class="mx-3">
                        <v-spacer></v-spacer>
                        <v-select
                            v-if="kollelApplication.kollelType == 'satmar'"
                            color="success"
                            style="max-width: 300px;"
                            :items="satmarKollelNames"
                            v-model="kollelApplication.kollelName"
                            class="my-0 pt-0"
                            reverse
                            :rules="required"
                            label="כולל אברכים תורה ויראה"
                        ></v-select>
                    </v-layout>

                    <div v-if="kollelApplication.kollelType == 'other'">
                        <v-layout row class="mx-3">
                            <v-text-field
                                autocomplete="new-password"
                                label="כולל אדרעס"
                                v-model="kollelApplication.kollelAddress"
                                ref="kollelAddress"
                                :rules="required"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="נאמען פון כולל"
                                v-model="kollelApplication.kollelName"
                                ref="kollelName"
                                :rules="required"
                                class="ml-3"
                                reverse
                            ></v-text-field>
                        </v-layout>
                        <v-layout row class="mx-3">
                            <v-text-field
                                autocomplete="new-password"
                                label="ראש הכולל סעלפאן"
                                v-model="kollelApplication.roshHakollelPhone"
                                ref="roshHakollelPhone"
                                :rules="required"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                class="ml-3"
                                label="ראש הכולל"
                                v-model="kollelApplication.roshHakollel"
                                ref="roshHakollel"
                                :rules="required"
                                reverse
                            ></v-text-field>
                        </v-layout>
                        <v-layout row class="mx-3">
                            <v-text-field
                                autocomplete="new-password"
                                label="פון וועלכע יאר לערנט איר אין דעם כולל"
                                v-model="kollelApplication.kollelStartingYear"
                                ref="kollelStartingYear"
                                :rules="required"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="כולל אפיס טעלעפאן"
                                v-model="kollelApplication.kollelPhone"
                                class="ml-3"
                                ref="kollelPhone"
                                :rules="required"
                                reverse
                            ></v-text-field>
                        </v-layout>
                    </div>
                    <v-layout row class="pa-0 ma-0">
                        <v-divider
                            style="border-color: #4caf50; margin-top: 13px;"
                            class="mt-2 pt-2"
                        ></v-divider>
                        <div class="font-weight-medium ml-2">
                            נאכמיטאג כולל
                        </div>
                    </v-layout>
                    <v-layout row class="pa-0 ma-0">
                        <v-spacer></v-spacer>
                        <div class="caption">
                            (אויב לערנט איר אין אן אנדערן כולל)
                        </div></v-layout
                    >
                    <v-layout row justify-end align-end>
                        <v-spacer></v-spacer>
                        <v-radio-group
                            v-model="kollelApplication.kollelType2"
                            row
                            style="max-width: 326px"
                        >
                            <v-radio
                                label="אנדערע כולל"
                                value="other"
                                color="success"
                            ></v-radio>
                            <v-radio
                                label="כולל אברכים תורה ויראה"
                                value="satmar"
                                color="success"
                            ></v-radio>
                        </v-radio-group>
                    </v-layout>
                    <v-layout row justify-end align-end class="mx-3">
                        <v-spacer></v-spacer>
                        <v-select
                            v-if="kollelApplication.kollelType2 == 'satmar'"
                            color="success"
                            style="max-width: 300px;"
                            :items="satmarKollelNames"
                            v-model="kollelApplication.kollelName2"
                            class="my-0 pt-0"
                            reverse
                            label="כולל אברכים תורה ויראה"
                        ></v-select>
                    </v-layout>

                    <div v-if="kollelApplication.kollelType2 == 'other'">
                        <v-layout row class="mx-3">
                            <v-text-field
                                autocomplete="new-password"
                                label="כולל אדרעס"
                                v-model="kollelApplication.kollelAddress2"
                                ref="kollelAddress2"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="נאמען פון כולל"
                                v-model="kollelApplication.kollelName2"
                                ref="kollelName2"
                                reverse
                                class="ml-3"
                            ></v-text-field>
                        </v-layout>
                        <v-layout row class="mx-3">
                            <v-text-field
                                autocomplete="new-password"
                                label="ראש הכולל סעלפאן"
                                v-model="kollelApplication.roshHakollelPhone2"
                                ref="roshHakollelPhone2"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                label="ראש הכולל"
                                v-model="kollelApplication.roshHakollel2"
                                ref="roshHakollel2"
                                reverse
                                class="ml-3"
                            ></v-text-field>
                        </v-layout>
                        <v-layout row class="mx-3">
                            <v-text-field
                                autocomplete="new-password"
                                label="פון וועלכע יאר לערנט איר אין דעם כולל"
                                v-model="kollelApplication.kollelStartingYear2"
                                ref="kollelStartingYear2"
                                reverse
                            ></v-text-field>
                            <v-text-field
                                autocomplete="new-password"
                                class="ml-3"
                                label="כולל אפיס טעלעפאן"
                                v-model="kollelApplication.kollelPhone2"
                                ref="kollelPhone2"
                                reverse
                            ></v-text-field>
                        </v-layout>
                    </div>

                    <v-layout row class="pa-0 ma-0">
                        <v-divider
                            style="border-color: #4caf50; margin-top: 13px;"
                            class="mt-2 pt-2"
                        ></v-divider>
                        <div class="font-weight-medium ml-2">
                            פרנסה
                        </div>
                    </v-layout>
                    <v-layout row justify-end align-end class="mx-3">
                        <v-spacer></v-spacer>
                        <v-select
                            color="success"
                            reverse
                            :items="['ניין', 'יא']"
                            v-model="kollelApplication.wifeHasJob"
                            class="my-0"
                            style="max-width: 300px;"
                            :rules="required"
                            label="האט די בעה'ב'סטע א דזשאב/פרנסה"
                        ></v-select>
                    </v-layout>
                    <v-layout
                        row
                        v-if="kollelApplication.wifeHasJob == 'יא'"
                        class="mx-3"
                    >
                        <v-text-field
                            autocomplete="new-password"
                            label="וויפיל יאר ארבעט מען דארט"
                            type="number"
                            v-model="kollelApplication.wivesJobYears"
                            ref="wivesJobYears"
                            reverse
                            :rules="required"
                        ></v-text-field>
                        <v-text-field
                            autocomplete="new-password"
                            label="פאזיצע"
                            v-model="kollelApplication.wivesPosition"
                            ref="wivesPosition"
                            class="ml-3"
                            :rules="required"
                            reverse
                        ></v-text-field>
                        <v-text-field
                            autocomplete="new-password"
                            label="נאמען פון ביזנעס/בעה''ב"
                            v-model="kollelApplication.wivesJob"
                            ref="wivesJob"
                            class="ml-3"
                            :rules="required"
                            reverse
                        ></v-text-field>
                    </v-layout>
                    <v-layout row justify-end align-end class="mx-3">
                        <v-spacer></v-spacer>
                        <v-select
                            color="success"
                            :items="['ניין', 'יא']"
                            v-model="kollelApplication.hasJob"
                            class="my-0"
                            :rules="required"
                            reverse
                            style="max-width: 300px"
                            label="זענט איר עוסק אין סיי וועלכע פרנסה"
                        ></v-select
                    ></v-layout>
                    <v-layout
                        class="mx-3"
                        row
                        v-if="kollelApplication.hasJob == 'יא'"
                    >
                        <v-text-field
                            autocomplete="new-password"
                            label="וועלכע פרנסה זענט איר עוסק"
                            v-model="kollelApplication.sideJob"
                            ref="sideJob"
                            :rules="required"
                            reverse
                        ></v-text-field>
                    </v-layout>

                    <v-text-field
                        class="mx-3"
                        autocomplete="new-password"
                        label="Note"
                        v-model="kollelApplication.note"
                        ref="note"
                        reverse
                    ></v-text-field>
                    <!-- <v-select
                                label="Status"
                                :items="[
                                    'SUBMITTED',
                                    'APPROVED FULL KOLLEL',
                                    'APPROVED KOLLEL WITH SIDE INCOME',
                                ]"
                                v-model="kollelApplication.status"
                                ref="status"
                            ></v-select> -->
                </div>
                <div class="text-xs-center mb-0" style="direction: rtl;">
                    {{ getMessage("SIDE_NOTE") }}
                </div>
                <v-layout row>
                    <v-spacer></v-spacer>
                    <div class="mb-0 headline">
                        הנני מאשר בזה שכל מה שכתוב ומפורש לעיל המה אמת וצדק
                    </div>
                    <v-checkbox
                        class="ml-2 mt-0 pb-3"
                        v-model="verifyForm"
                        color="success"
                        hide-details
                    ></v-checkbox>
                </v-layout>
                <div
                    class="text-danger text-xs-center"
                    v-if="showMissingVerification"
                >
                    Please check the box above
                </div>
            </v-form>
            <v-card-actions class="mr-0 mt-2 pb-0">
                <v-btn
                    color="success"
                    :loading="processing"
                    @click="saveKollelApllication"
                >
                    Save
                </v-btn>
                <v-btn dark color="default" @click="cancel">Cancel</v-btn>
            </v-card-actions>
        </v-card>
        <v-layout row wrap xs12>
            <div v-for="form in getOldForms()" class="ml-2">
                <v-card
                    class="pa-3 ma-2"
                    xs4
                    @click="onApplicationClicked(form)"
                    style="border: 3px solid green; border-radius: 10px; cursor: pointer;"
                >
                    <div class="headline">
                        {{ form.regID + " Application" }}
                    </div>
                </v-card>
            </div>
        </v-layout>
        <v-dialog v-model="oldApplicationDialog" max-width="490">
            <v-card class="pa-3">
                <v-card-title class="pl-0 py-0 headline mb-2">{{
                    clickApplication.regID + " Application"
                }}</v-card-title>
                <div
                    class="pa-2"
                    style="overflow-y: auto; height: 400px; border: 2px solid #4caf50"
                >
                    <div
                        class="layout row mb-2 pa-0 mx-0"
                        v-for="prop in getRowProperties(clickApplication)"
                    >
                        <div class="font-weight-medium mr-1 width-200">
                            {{ prop.name }}:
                        </div>
                        <div>{{ prop.value }}</div>
                    </div>
                </div>
                <v-card-actions class="mr-0 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="oldApplicationDialog = false"
                        >Close</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="copyApplication(clickApplication)"
                        >Copy To Current</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { formatPhoneNumber, except, toTitleCase } from "../../utils/helpers.js";
import moment from "moment";

export default {
    data() {
        return {
            account: "",
            kollelApplicationDialog: false,
            kollelApplicationDialogWidth: "800",
            processing: false,
            uploading: false,
            files: [],
            kollelForms: [],
            kollelApplicationDocuments: [],
            kollelApplicationMessages: [],

            required: [(value) => !!value || "Required."],

            pdfDucmentNumberOfPages: "",

            pageCount: 0,
            currentPage: 0,

            clickApplication: {},
            oldApplicationDialog: false,

            satmarKollelNames: [
                "סניף תהלות יואל",
                "סניף קליימער",
                "סניף קיעפ קומה א",
                "סניף קיעפ קומה ב",
                "כולל גפ״ת",
            ],

            verifyForm: false,
            showMissingVerification: false,
            showKollelTypeMissing: false,

            kollelApplication: {
                id: "",
                onKollelPayroll: "",
                kollelTimeAllDay: "",
                kollelName: "",
                kollelAddress: "",
                kollelTime: "",
                roshHakollel: "",
                kollelName2: "",
                kollelAddress2: "",
                kollelTime2: "",
                roshHakollel2: "",
                roshHakollelPhone: "",
                roshHakollelPhone2: "",
                kollelPhone: "",
                kollelStartingYear: "",
                kollelPhone2: "",
                kollelStartingYear2: "",
                hasJob: false,
                sideJob: "",
                wifeHasJob: false,
                wivesJob: "",
                wivesPosition: "",
                wivesJobYears: "",
                note: "",
                status: "SUBMITTED",
                documentURL: "",
                source: "",
                kollelType: "",
                kollelType2: "",
                name: "",
                homePhone: "",
                address: "",
            },
        };
    },
    async created() {
        await this.loadAccount();

        const response = await this.$http.get(
            "api/kollelForms/getApplication?accountID=" +
                this.account.accountID,
        );

        this.kollelForms = response.kollelForms;

        this.fillForm({ id: this.$route.params.id });

        this.loadStrings();
    },
    computed: {},
    methods: {
        async loadAccount() {
            this.account = await this.$http.get(
                "api/accounts/GetAccount?accountID=" +
                    this.$route.params.accountid,
            );
        },
        formatPhoneNumber(phone) {
            return formatPhoneNumber(phone);
        },
        getMessage(key) {
            if (!this.kollelApplicationMessages.length) return;

            return this.kollelApplicationMessages.find((m) => m.key == key)
                .value;
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                this.files = files;

                formData.append("upload_file", this.files[0]);

                const response = await this.$http.post(
                    "api/kollelForms/uploadKollelApplication?accountID=" +
                        this.account.accountID,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.kollelApplication.documentURL = response;

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        updatePdfPages() {
            pdfjsLib
                .getDocument(this.kollelApplication.documentURL)
                .then((doc) => {
                    this.pdfDucmentNumberOfPages = doc.numPages;
                    console.log(doc.numPages);
                });
        },
        onApplicationClicked(form) {
            this.clickApplication = form;
            this.oldApplicationDialog = true;
        },
        openDocument() {
            window.open(this.kollelApplication.documentURL);
        },
        deleteDocument() {
            this.kollelApplication.documentURL = "";
        },
        async fillForm({ id = null, isCopy = false }) {
            this.kollelApplication.name = this.account.hname;
            this.kollelApplication.homePhone = this.account.homePhone;
            this.kollelApplication.address = this.account.address1;

            const form = id
                ? this.kollelForms.find((f) => f.id == id)
                : this.kollelForms.length
                ? this.kollelForms[0]
                : undefined;

            if (form) {
                if (!isCopy) {
                    this.kollelApplication.id = form.id;
                }
                this.kollelApplication.onKollelPayroll = form.onKollelPayroll
                    ? "יא"
                    : "ניין";
                this.kollelApplication.kollelTimeAllDay =
                    form.kollelTime == "allday"
                        ? "יא"
                        : form.kollelTime == "morning"
                        ? "ניין"
                        : "";
                this.kollelApplication.kollelName = form.kollelName;
                this.kollelApplication.kollelType = form.kollelType;
                this.kollelApplication.kollelType2 = form.kollelType2;
                this.kollelApplication.kollelAddress = form.kollelAddress;
                this.kollelApplication.kollelTime = form.kollelTime;
                this.kollelApplication.roshHakollel = form.roshHakollel;
                this.kollelApplication.roshHakollelPhone =
                    form.roshHakollelPhone;
                this.kollelApplication.roshHakollelPhone2 =
                    form.roshHakollelPhone2;
                this.kollelApplication.kollelName2 = form.kollelName2;
                this.kollelApplication.kollelAddress2 = form.kollelAddress2;
                this.kollelApplication.kollelTime2 = form.kollelTime2;
                this.kollelApplication.roshHakollel2 = form.roshHakollel2;
                this.kollelApplication.kollelPhone = form.kollelPhone;
                this.kollelApplication.kollelStartingYear =
                    form.kollelStartingYear;
                this.kollelApplication.kollelPhone2 = form.kollelPhone2;
                this.kollelApplication.kollelStartingYear2 =
                    form.kollelStartingYear2;

                this.kollelApplication.hasJob = form.hasJob ? "יא" : "ניין";
                this.kollelApplication.sideJob = form.sideJob;
                this.kollelApplication.wifeHasJob = form.wifeHasJob
                    ? "יא"
                    : "ניין";
                this.kollelApplication.wivesJob = form.wivesJob;
                this.kollelApplication.wivesPosition = form.wivesPosition;
                this.kollelApplication.wivesJobYears = form.wivesJobYears;
                this.kollelApplication.note = form.note;
                this.kollelApplication.status = form.status;
                this.kollelApplication.documentURL = form.documentURL;
                this.kollelApplication.source = form.source;
                this.verifyForm = form.signatureBase64String ? true : false;
            }

            this.$refs.form.resetValidation();

            this.kollelApplicationDialog = true;
        },
        async loadStrings() {
            this.kollelApplicationMessages = await this.$http.get(
                "api/kollelForms/getStrings",
            );
        },
        collectFormData() {
            return {
                id: this.kollelApplication.id || 0,
                date: moment().format("YYYY-MM-DD HH:mm:ss"),
                accountID: this.account.accountID,
                name: this.account.hname,
                homePhone: this.account.homePhone.replace(/\D/g, ""),
                address: this.account.address1,
                cellphone: this.account.cellPhone.replace(/\D/g, ""),
                father: this.account.father,
                fatherInLaw: this.account.shver,
                kollelName: this.kollelApplication.kollelName,
                kollelAddress: this.kollelApplication.kollelAddress,
                kollelTime:
                    this.kollelApplication.kollelTimeAllDay == "יא"
                        ? "allday"
                        : "morning",
                roshHakollel: this.kollelApplication.roshHakollel,
                roshHakollelPhone: this.kollelApplication.roshHakollelPhone
                    ? this.kollelApplication.roshHakollelPhone.replace(
                          /\D/g,
                          "",
                      )
                    : "",
                kollelName2: this.kollelApplication.kollelName2,
                kollelAddress2: this.kollelApplication.kollelAddress2,
                kollelTime2: this.kollelApplication.kollelTime2,
                kollelType: this.kollelApplication.kollelType,
                kollelType2: this.kollelApplication.kollelType2,
                roshHakollel2: this.kollelApplication.roshHakollel2,
                roshHakollelPhone2: this.kollelApplication.roshHakollelPhone2
                    ? this.kollelApplication.roshHakollelPhone2.replace(
                          /\D/g,
                          "",
                      )
                    : "",
                kollelPhone: this.kollelApplication.kollelPhone,
                kollelStartingYear: this.kollelApplication.kollelStartingYear,
                kollelPhone2: this.kollelApplication.kollelPhone2,
                kollelStartingYear2: this.kollelApplication.kollelStartingYear2,
                onKollelPayroll: this.kollelApplication.onKollelPayroll == "יא",
                documentURL: this.kollelApplication.documentURL,
                sideJob:
                    this.kollelApplication.hasJob == "יא"
                        ? this.kollelApplication.sideJob
                        : null,
                wifeHasJob: this.kollelApplication.wifeHasJob == "יא",
                hasJob: this.kollelApplication.hasJob == "יא",
                wivesJob:
                    this.kollelApplication.wifeHasJob == "יא"
                        ? this.kollelApplication.wivesJob
                        : null,
                wivesPosition:
                    this.kollelApplication.wifeHasJob == "יא"
                        ? this.kollelApplication.wivesPosition
                        : null,
                wivesJobYears:
                    this.kollelApplication.wifeHasJob == "יא"
                        ? this.kollelApplication.wivesJobYears
                        : null,
                source: this.kollelApplication.source
                    ? this.kollelApplication.source
                    : "ADMIN PORTAL",
                status: this.kollelApplication.status,
                note: this.kollelApplication.note,
                updatedBy: this.$store.state.authentication.user,
            };
        },
        cancel() {
            this.$router.push({
                name: "KollelApplications",
            });
        },
        async saveKollelApllication() {
            this.showMissingVerification = false;
            this.showKollelTypeMissing = false;

            if (!this.$refs.form.validate(true)) return;

            if (!this.kollelApplication.kollelType) {
                this.showKollelTypeMissing = true;
                return;
            }

            // if (
            //     !this.kollelApplication.documentURL &&
            //     this.kollelApplication.source != "DDC"
            // ) {
            //     return this.$notify({
            //         text: "Please Upload Application",
            //         group: "notification",
            //         type: "error",
            //     });
            // }

            if (!this.verifyForm) {
                this.showMissingVerification = true;

                return;
            }

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/kollelForms/fillKollelForm",
                    this.collectFormData(),
                );

                this.processing = false;
                this.kollelApplicationDialog = false;

                this.$router.push({
                    name: "KollelApplications",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        copyApplication(form) {
            this.fillForm({ id: form.id, isCopy: true });

            this.clickApplication = {};
            this.oldApplicationDialog = false;
        },
        getOldForms() {
            if (!this.$route.params.id) return;

            return this.kollelForms.filter(
                (f) =>
                    f.id != this.$route.params.id &&
                    !["REJECTED", "DELETED"].includes(f.status),
            );
        },
        getRowProperties(form) {
            return Object.keys(
                except(
                    form,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "signature",
                    "applicationDocument",
                ),
            )
                .map((key) => {
                    // const column = this.columns
                    //     .filter((c) => !c.isIcon)
                    //     .find((c) => c.field == key);

                    // if (!column) return { value: null };

                    const value =
                        ["date", "approvedAt", "updatedAt"].includes(key) &&
                        form[key]
                            ? this.formatTime(form[key])
                            : form[key];

                    return {
                        name: toTitleCase(key), //column ? column.label : toTitleCase(key),
                        value: value,
                    };
                })
                .filter((p) => p.value);
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
    },
};
</script>
<style>
.card-width {
    max-width: 65%;
}
</style>
